import React, {useEffect, useState} from 'react';
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import {useCurrentResolution} from "../../../../../Hooks/useCurrentResolution";
import SimpleForEach from "./SimpleForEach";
import VirtualForEach from "./VirtualForEach";
import {useResponsiveStyles} from "../../../../../Hooks/useResponsiveStyles";

const ForEachComponent = (props) => {
    const {
        component: {
            properties: {
                path, creatable, removable, editScreen, list, isVirtual,
                containerId, noDataLabel, maxItemsRender, skipInitDataLoad
            } = {},
            children = [], styles: sourceStyles, events = []
        },
        globalValues, containerArrayPath, addGroup, removeGroup, actionsContext,
        screenName
    } = props;
    const [arrayToRender, setArrayToRender] = useState([]);
    const isStartsDoc = path?.startsWith('doc')
    const forEachPath = (containerArrayPath && !isStartsDoc) ? containerArrayPath + '.' + path.split('.').slice(path.split('.').length - 1).join('.') : path;
    const currentArray = findByString({...globalValues.param[screenName], ...actionsContext}, forEachPath);
    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(sourceStyles, currentResolution);
    const adaptiveWidth = typeof styles.width === 'object' ? styles.width[currentResolution] : styles.width;

    useEffect(() => {
        if (currentArray && Array.isArray(currentArray)) {
            setArrayToRender(currentArray);
        }
    }, [currentArray]);

    return (isVirtual ? (
            <VirtualForEach
                path={forEachPath}
                children={children}
                adaptiveWidth={adaptiveWidth}
                arrayToRender={arrayToRender}
                containerArrayPath={forEachPath}
                creatable={creatable}
                removable={removable}
                actionsContext={actionsContext}
                list={list}
            />
        ) : (
            <SimpleForEach
                path={forEachPath}
                children={children}
                adaptiveWidth={adaptiveWidth}
                arrayToRender={arrayToRender}
                containerArrayPath={forEachPath}
                creatable={creatable}
                removable={removable}
                actionsContext={actionsContext}
                addGroup={addGroup}
                removeGroup={removeGroup}
                editScreen={editScreen}
                styles={styles}
                list={list}
                events={events}
                screenName={screenName}
                containerId={containerId}
                noDataLabel={noDataLabel}
                maxItemsRender={maxItemsRender}
                skipInitDataLoad={skipInitDataLoad}
            />
        )
    )
};
ForEachComponent.defaultProps = {
    actionsContext: {
        isVisibleTab: true
    }
}
const ForEachMemoized = React.memo(ForEachComponent)
export default JsonScreenHoc(ForEachMemoized);